// extracted by mini-css-extract-plugin
export var addToCartButton = "_l5-b";
export var arrowButtonContainer = "_l5-9";
export var arrowButtonIcon = "_l5-a";
export var carouselArrowButton = "_l5-6";
export var carouselElementContainer = "_l5-1";
export var left = "_l5-7";
export var productDisplayCarouselContainer = "_l5-0";
export var productTileContainer = "_l5-2";
export var productTileImage = "_l5-4";
export var productTileImageContainer = "_l5-3";
export var productTileTitle = "_l5-5";
export var right = "_l5-8";
export var sliderOverflow = "_l5-c";